<div style="margin-left: 30px; margin-top: 10px; margin-bottom: 30px">
  <div style="display: inline-block">
    <span class="dot"></span>
  </div>

  <div style="display: inline-block; margin-left: 15px">
    {{ title }}
  </div>

  <div style="margin-left: 25px; margin-top: 5px; font-size: 12px">
    {{ date }}
  </div>
</div>
